// @flow

import React from 'react';
import RelayEnvironmentContext, {
  type RelayEnvironmentType as RelayEnvironmentT,
  type RelayEnvironmentContextType,
} from './context/relayEnvironment';

const withRelayEnvironment = (Component: Function) => {
  const RelayEnvWrapper = (props: Object) => (
    <RelayEnvironmentContext.Consumer>
      {({ relayEnvironment }: RelayEnvironmentContextType) => (
        <Component {...props} relayEnvironment={relayEnvironment} />
      )}
    </RelayEnvironmentContext.Consumer>
  );

  const displayName = Component.displayName || Component.name || 'Component';
  RelayEnvWrapper.displayName = `withRelayEnvironment(${displayName})`;

  return RelayEnvWrapper;
};

export type RelayEnvironmentType = RelayEnvironmentT;

export default withRelayEnvironment;
